module.exports = __webpack_public_path__ + "static/media/bg@2x.a39d0c5e.png";